export const SITE_LIVE_MODAL_STORAGE_KEY = "tk_site_live_modal_v1";

const SEEN_VALUE = "1";

export function markSiteLiveModalSeen(): void {
  try {
    localStorage.setItem(SITE_LIVE_MODAL_STORAGE_KEY, SEEN_VALUE);
  } catch {
    /* private browsing / blocked storage */
  }
}

export function hasSiteLiveModalBeenSeen(): boolean {
  try {
    return localStorage.getItem(SITE_LIVE_MODAL_STORAGE_KEY) === SEEN_VALUE;
  } catch {
    return true;
  }
}
